  // import React, { useEffect } from "react";
  // import { useDispatch, useSelector } from "react-redux";
  // import { Modal } from "@mui/material";
  // import { Close } from "@mui/icons-material";
  // import {
  //   setModalState,
  //   selectModalState,
  //   selectImages,
  // } from "../../../Store/Gmb/gmbImageSlice";


  // const ImageModal = ({imageList}) => {
  //   const dispatch = useDispatch();
  //   const { isOpen, currentImageIndex } = useSelector(selectModalState);

  //   console.log({imageList})

  //   const handleClose = () => {
  //     dispatch(setModalState({ isOpen: false }));
  //   };

  //   const handleNext = () => {
  //     dispatch(
  //       setModalState({
  //         currentImageIndex: (currentImageIndex + 1) % imageList?.length,
  //       }),
  //     );
  //   };

  //   // Keyboard event handling for navigation and closing the modal
  //   useEffect(() => {
  //     const handleKeyDown = (event) => {
  //       if (event.key === "ArrowRight") {
  //         handleNext();
  //       } else if (event.key === "ArrowLeft") {
  //         handlePrev();
  //       } else if (event.key === "Escape") {
  //         handleClose();
  //       }
  //     };

  //     if (isOpen) {
  //       window.addEventListener("keydown", handleKeyDown);
  //     } else {
  //       window.removeEventListener("keydown", handleKeyDown);
  //     }

  //     // Cleanup event listener on component unmount or when modal closes
  //     return () => {
  //       window.removeEventListener("keydown", handleKeyDown);
  //     };
  //   }, [isOpen, currentImageIndex]);

  //   const handlePrev = () => {
  //     dispatch(
  //       setModalState({
  //         currentImageIndex:
  //           currentImageIndex === 0 ? imageList?.length - 1 : currentImageIndex - 1,
  //       }),
  //     );
  //   };

  //   if (!isOpen) return null;

  //   return (
  //     <Modal
  //       open={isOpen}
  //       onClose={handleClose}
  //       className="flex items-center justify-center"
  //     >
  //       <div className="relative flex items-center justify-center w-full h-full bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm">
  //         <button
  //           className="absolute text-white top-4 right-4"
  //           onClick={handleClose}
  //         >
  //           <Close fontSize="large" />
  //         </button>
  //         <img
  //           src={imageList[currentImageIndex]}
  //           alt={`${currentImageIndex + 1}`}
  //           className="object-contain w-2/3 h-2/3"
  //         />
  //         {imageList?.length > 1 && (
  //           <>
  //             <button
  //               onClick={handlePrev}
  //               className="absolute p-2 transition-all duration-200 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full top-1/2 left-4 hover:bg-opacity-75"
  //               aria-label="Previous slide"
  //             >
  //               <svg
  //                 xmlns="http://www.w3.org/2000/svg"
  //                 className="w-6 h-6"
  //                 fill="none"
  //                 viewBox="0 0 24 24"
  //                 stroke="currentColor"
  //               >
  //                 <path
  //                   strokeLinecap="round"
  //                   strokeLinejoin="round"
  //                   strokeWidth={2}
  //                   d="M15 19l-7-7 7-7"
  //                 />
  //               </svg>
  //             </button>
  //             <button
  //               onClick={handleNext}
  //               className="absolute p-2 transition-all duration-200 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full top-1/2 right-4 hover:bg-opacity-75"
  //               aria-label="Next slide"
  //             >
  //               <svg
  //                 xmlns="http://www.w3.org/2000/svg"
  //                 className="w-6 h-6"
  //                 fill="none"
  //                 viewBox="0 0 24 24"
  //                 stroke="currentColor"
  //               >
  //                 <path
  //                   strokeLinecap="round"
  //                   strokeLinejoin="round"
  //                   strokeWidth={2}
  //                   d="M9 5l7 7-7 7"
  //                 />
  //               </svg>
  //             </button>
  //           </>
  //         )}
  //       </div>
  //     </Modal>
  //   );
  // };

  // export default ImageModal;


  import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";

const ImageModal = ({
  isOpen,
  currentImageIndex = 0,
  imageList = [],
  onClose,
  onNext,
  onPrev,
}) => {
  // Keyboard navigation handling
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight" && onNext) {
        onNext();
      } else if (event.key === "ArrowLeft" && onPrev) {
        onPrev();
      } else if (event.key === "Escape" && onClose) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onNext, onPrev, onClose]);

  // Prevent rendering if no images or modal is closed
  if (!isOpen || !imageList.length) return null;

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className="flex items-center justify-center"
      aria-labelledby="image-modal"
      aria-describedby="view-image-modal"
    >
      <div className="relative flex items-center justify-center w-full h-full bg-black bg-opacity-50 backdrop-filter backdrop-blur-sm">
        <button
          className="absolute text-white top-4 right-4"
          onClick={onClose}
          aria-label="Close modal"
        >
          <Close fontSize="large" />
        </button>
        <img
          src={imageList[currentImageIndex]}
          alt={`Image ${currentImageIndex + 1}`}
          className="object-contain w-2/3 h-2/3"
        />
        {imageList.length > 1 && (
          <>
            <button
              onClick={onPrev}
              className="absolute p-2 transition-all duration-200 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full top-1/2 left-4 hover:bg-opacity-75"
              aria-label="Previous image"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>
            <button
              onClick={onNext}
              className="absolute p-2 transition-all duration-200 transform -translate-y-1/2 bg-white bg-opacity-50 rounded-full top-1/2 right-4 hover:bg-opacity-75"
              aria-label="Next image"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </>
        )}
      </div>
    </Modal>
  );
};

// Prop Types
ImageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  currentImageIndex: PropTypes.number,
  imageList: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
};

// Default Props
ImageModal.defaultProps = {
  currentImageIndex: 0,
};

export default ImageModal;

